import { render } from "./MenuList.vue?vue&type=template&id=6f870611&scoped=true"
import script from "./MenuList.vue?vue&type=script&lang=js"
export * from "./MenuList.vue?vue&type=script&lang=js"

import "./MenuList.vue?vue&type=style&index=0&id=6f870611&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f870611"]])

export default __exports__